
export class ScreenResolutions{
    static DesktopResolution = 1251;
    static MobileResolution = 1249;
}
